export default __webpack_public_path__ + "static/media/right-arrow.0bec58ba.svg";